import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { DATE_FORMAT, PAGE_SIZE } from '../../../_common/constant';
import Icon from '../../../components/icons';
import { useLocation, useParams } from 'react-router-dom';
import { useAssetsApi } from '../../../store/api/hooks/assetsApiHook';
import { AgGridReact } from 'ag-grid-react';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Button from '../../../components/elements/button';
import Drawer from '../../../components/Drawer';
import CreateWarrenty from './createWarrenty';
import toast from 'react-hot-toast';
import { downloadExcel, getPermissionInfo, showLocalDate } from '../../../_common/functions';
import Currency from '../../../components/currency';
import { useUserSelector } from '../../../store/selectors/userSelector';

interface WarrantyProps {
    reloadKey: number;
}
const Warranty: React.FC<WarrantyProps> = ({ reloadKey }) => {
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const params: any = useParams();
    const assetsAPI = useAssetsApi();
    const [columnDefs, setColumnDefs] = useState<any[] | null>(null);
    const [gridApi, setGridApi] = useState<any>(null);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const { confirm } = useDialog();
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [attachments, setAttachment] = useState<[]>([]);
    const { showLoader, hideLoader } = useAppLoader();
    const addWarrentyDrawerRef: any = React.createRef<HTMLButtonElement>();
    const addNewWarrentyRef: any = useRef();
    const [warranty, setWarranty] = useState<any>(null);
    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                // Implement edit action
                setWarranty(rowData);
                addWarrentyDrawerRef.current.open();
                console.log("Edit action for row: ", rowData);
                break;
            case "delete":
                // Implement delete action

                break;
            case "duplicate":
                console.log("Duplicate action for row: ", rowData);
                break;
            case "move-asset":
                // Implement move asset action
                console.log("Move Asset action for row: ", rowData);
                break;

            case "schedule-maintenance":
                // Implement schedule maintenance action
                console.log("Schedule Maintenance action for row: ", rowData);
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };
    const getSelectedRows = () => {
        const selectedNodes = gridApi?.getSelectedNodes();
        const selectedData = selectedNodes.map((node: any) => node.data);
        return selectedData;
    };
    const onBulkExportCsv = async () => {
        // Check export permission
        if (!getPermissionInfo(location.pathname, "Export", loggedinuser)) {
            toast.error("You don't have permission to export");
            return;
        } else {
            const selectedData = getSelectedRows();

            if (selectedData.length == 0) {
                toast.error("Nothing is selected")
            } else {
                console.log("selectedData", selectedData)
                const warrantyIDs = selectedData.map((asset: any) => asset.warrantyID).join(',');

                //   const payload = { assetIDs: assetIDs };
                const payload = { assetID: params.id, warrantyIDs: warrantyIDs };
                assetsAPI.WarrantyExportToXLS(
                    payload,
                    (resp: any) => { downloadExcel(resp, 'WarrantyXls') },
                    (error: any) => {
                        console.log("error =>", error);
                        toast.error(error);
                    }
                );
            }
        }
    };

    useEffect(() => {
        setColumnDefs([
            { headerCheckboxSelection: true, checkboxSelection: true, width: 50, headerClass: 'bg-[#f0f0f0]' },

            {
                headerName: "Vendor Doc No",
                width: 220,
                field: "vendorDocNo",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold ">
                            {data?.data?.vendorDocNo
                                ? data?.data?.vendorDocNo
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Vendor",
                field: "vendorName",
                headerClass: "bg-[#f0f0f0] ",
                minWidth: 250,
                flex: 1,
                cellRenderer: (data: any) => {
                    return (
                        <p title={`${data?.data?.vendorName
                            ? data?.data?.vendorName
                            : "-"}`} className="hover:text-primary font-semibold   text-ellipsis overflow-hidden">
                            {data?.data?.vendorName
                                ? data?.data?.vendorName
                                : "-"}
                        </p>
                    );
                },
            },

            {
                headerName: "Start Date",
                width: 170,
                field: "warrantyStartDate",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold ">
                            {data?.data?.warrantyStartDate
                                ? showLocalDate(data?.data?.warrantyStartDate)
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "End Date",
                width: 170,
                field: "warrantyEndDate",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold ">
                            {data?.data?.warrantyEndDate
                                ? showLocalDate(data?.data?.warrantyEndDate)
                                : "-"}
                        </p>
                    );
                },
            },
            {
                headerName: "Days Until Expiry",
                width: 200,
                field: "daysUntillExpiry",
                headerClass: "bg-[#f0f0f0]",
                cellRenderer: (data: any) => {
                    const daysUntilExpiry = data?.data?.daysUntillExpiry;

                    let displayText;
                    if (daysUntilExpiry !== undefined && daysUntilExpiry !== "-") {
                        if (parseInt(daysUntilExpiry) < 0) {
                            //  displayText = `Expired ${Math.abs(parseInt(daysUntilExpiry))} days ago`;

                            displayText = `Expired`;
                        } else {
                            displayText = daysUntilExpiry + ' days';
                        }
                    } else {
                        displayText = "-";
                    }
                    return (
                        <p className="hover:text-primary font-semibold  ">

                            {displayText}
                        </p>
                    );
                },
            },





            {
                headerName: "Warranty Terms",
                field: "warrantyTermsName",
                headerClass: "bg-[#f0f0f0] text-center",
                width: 230,

                cellRenderer: (data: any) => {
                    return (
                        <p title={`${data?.data?.warrantyTermsName
                            ? data?.data?.warrantyTermsName
                            : "-"}`} className="hover:text-primary font-semibold   text-ellipsis overflow-hidden">
                            {data?.data?.warrantyTermsName
                                ? data?.data?.warrantyTermsName
                                : "-"}
                        </p>
                    );
                },
            },

            {
                headerName: "Cost",
                field: "warrantyAMCCost",
                headerClass: "bg-[#f0f0f0] text-center",
                width: 230,
                cellClass: 'ag-right-aligned-cell',
                cellRenderer: (data: any) => {
                    return (
                        <p className="hover:text-primary font-semibold ">
                            <Currency currency="USD" value={data?.data?.warrantyAMCCost} />
                        </p>
                    );
                },
            },
            {
                headerName: "Action",
                field: "actions",
                headerClass: "bg-[#f0f0f0] text-center",
                width: 90,

                cellRenderer: (params: any) => {
                    return (
                        <div className='relative h-full w-full flex items-center justify-center'>
                            <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();
                                const dropdown: any = document.querySelector('.action-dropdown');
                                if (dropdown) {
                                    dropdown.focus();
                                }
                                return false;
                            }} />
                            <select
                                onChange={(e) => {

                                    handleActionChange(e, params);
                                    //e.target.value = '';
                                }}
                                onFocus={(e) => {
                                    e.target.selectedIndex = -1;
                                }
                                }
                                className="action-dropdown"
                                value={''}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    opacity: 0,
                                    cursor: "pointer",
                                }}
                            >
                                <option value="edit">Update Warranty</option>

                            </select>
                        </div>
                    );
                },
            }
        ]);
    }, [params]);

    const GetWarrantyList = () => {
        let payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage,
            searchParam: searchParam,
            assetID: params.id
        };

        assetsAPI.GetWarrantyList(payload, (data: any) => {
            setAttachment(data.warrantyList ? data.warrantyList : []);
            setTotalRecords(data.totalRecord);
        }, (error: any) => { });
    };

    useEffect(() => {
        if (params.id) {
            GetWarrantyList();
        }

    }, [params, reloadKey]);
    useEffect(() => {

        GetWarrantyList();

    }, [currentPage, searchParam]);
    return (
        <div>

            <div className='flex items-center justify-between pl-5 pr-3 h-[3.75rem]'>
                <div className='flex items-center gap-2'>
                    <h1 className='text-[0.9rem] leading-[1]'>Warranty List</h1>
                    <Pagination
                        perPage={PAGE_SIZE}
                        totalRecords={totalRecords}
                        onPageChange={setCurrentPage}
                        currentPage={currentPage}
                    />
                </div>
                <div className='flex items-center gap-2'>
                    <Search onSearch={setSearchParam} />
                    <Button disabled={!getPermissionInfo(location.pathname, "Export", loggedinuser)} theme='light' onClick={() => {
                        onBulkExportCsv()
                    }} >Export</Button>
                    <Drawer _ref={addWarrentyDrawerRef} onClose={() => {
                        setWarranty(null);
                        GetWarrantyList();
                        addNewWarrentyRef?.current?.reset()

                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button >Create New Warranty</Button>
                        </Drawer.Button>
                        <Drawer.Content title={warranty ? 'Edit Warranty' : 'Create New Warranty'} className='!w-[39.563rem]'>
                            <CreateWarrenty _ref={addNewWarrentyRef} editData={warranty} onCreate={() => {
                                GetWarrantyList();
                                addNewWarrentyRef?.current?.reset()
                                setWarranty(null)
                                addWarrentyDrawerRef.current.close();

                            }} onCancel={() => {
                                GetWarrantyList();
                                setWarranty(null)
                                addNewWarrentyRef?.current?.reset()
                                addWarrentyDrawerRef.current.close();

                            }} />
                        </Drawer.Content>
                    </Drawer>
                </div>

            </div>
            <AgGridReact
                columnDefs={columnDefs} // Pass columnDefs
                rowData={attachments || []} // Pass rowData
                pagination={false}
                rowSelection="multiple"
                onGridReady={onGridReady}
                domLayout="autoHeight"
                onRowClicked={onRowClicked}
                noRowsOverlayComponent={() => (
                    <div className="flex items-center justify-center h-full">
                        <div className="text-center text-gray-500">
                            <div className="text-lg font-medium">No Data Found</div>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

export default Warranty;